export default __webpack_public_path__ + "static/media/doc-navy.d4928cb5.svg";